// 71吃瓜首页演示数据（纯静态内容，供首页展示使用）

export interface NewsItem {
  id: string;
  cat: string;
  title: string;
  summary: string;
  time: string;
  views: string;
  hot: boolean;
  img: string;
}

export const navCategories = [
  "今日速报",
  "热剧观察",
  "综艺现场",
  "新片快讯",
  "圈内动态",
  "热梗速递",
];

export const breakingStory = {
  tag: "今日头瓜",
  title: "暑期档新片接连定档，热门IP与原创题材同台竞技，票房预测两极分化",
  summary:
    "多家片方同一天官宣档期，现实主义题材与高概念类型片正面交锋。业内与网友对暑期档整体表现看法不一，话题讨论度迅速攀升，成为今日最受关注的头瓜。",
  time: "2026.09.06 09:12",
  views: "128.6万",
  img: "https://readdy.ai/api/search-image?query=editorial%20entertainment%20photography%20cinema%20release%20poster%20wall%20with%20warm%20amber%20backdrop%2C%20dramatic%20rim%20lighting%20and%20soft%20cinematic%20glow%2C%20paper%20texture%20tones%20of%20cream%20and%20coral%2C%20artful%20layered%20composition%2C%20magazine%20cover%20aesthetic%2C%20high%20detail&width=1200&height=630&seq=hero-break-01&orientation=landscape",
};

export const heroSideItems = [
  { id: "h1", title: "新综阵容官宣，网友追综热情高涨，首期预告播放量破纪录", views: "96.2万", tag: "综艺现场" },
  { id: "h2", title: "一部都市剧播出后口碑回暖，细节考究获观众二刷推荐", views: "88.4万", tag: "热剧观察" },
  { id: "h3", title: "老牌栏目迎来周年特别企划，情怀向内容引发集体回忆", views: "75.9万", tag: "圈内动态" },
];

export const hotRank = [
  { rank: 1, title: "暑期档新片定档潮引发票房走势大讨论", views: "128.6万", trend: "up" },
  { rank: 2, title: "新综艺阵容官宣，首期预告引全网围观", views: "96.2万", trend: "up" },
  { rank: 3, title: "都市剧口碑回暖，细节考究获观众二刷", views: "88.4万", trend: "up" },
  { rank: 4, title: "一档舞台竞演收官，冠军悬念留到最终章", views: "71.3万", trend: "down" },
  { rank: 5, title: "老牌栏目周年企划，情怀向内容引发回忆杀", views: "62.7万", trend: "up" },
  { rank: 6, title: "电影节红毯造型盘点，几套穿搭成讨论焦点", views: "58.1万", trend: "down" },
  { rank: 7, title: "热门IP续作首曝物料，画风质感成热议点", views: "49.8万", trend: "up" },
  { rank: 8, title: "一档音综翻唱舞台出圈，弹幕刷屏停不下来", views: "43.5万", trend: "down" },
];

export const latestNews: NewsItem[] = [
  {
    id: "n01",
    cat: "今日速报",
    title: "暑期档排片新动向：多部影片调整档期，热门席位争夺白热化",
    summary: "片方密集调档引发连锁反应，黄金档期竞争加剧。业内人士认为内容品质仍是最终胜负手，网友则在热议自己期待的新片会落在哪一周。",
    time: "2026.09.06 08:40",
    views: "38.2万",
    hot: false,
    img: "https://readdy.ai/api/search-image?query=cinema%20screening%20schedule%20boards%20and%20ticket%20counter%20with%20warm%20amber%20and%20coral%20color%20grade%2C%20soft%20cinematic%20lighting%2C%20editorial%20magazine%20photography%2C%20cream%20toned%20background%2C%20artful%20composition%2C%20high%20detail&width=800&height=500&seq=card-schedule-01&orientation=landscape",
  },
  {
    id: "n02",
    cat: "综艺现场",
    title: "一档野外冒险综艺路透曝光，嘉宾组合被网友戏称笑点担当",
    summary: "路透图中嘉宾们的互动画面被疯传，网友已经开始自发剪辑二创片段。节目组暂未回应档期，但讨论度已率先冲上多个平台。",
    time: "2026.09.06 07:55",
    views: "45.7万",
    hot: true,
    img: "https://readdy.ai/api/search-image?query=outdoor%20variety%20show%20camp%20set%20with%20camping%20lights%20and%20stage%20props%2C%20warm%20amber%20twilight%20color%20grade%2C%20editorial%20entertainment%20photography%2C%20soft%20cinematic%20glow%2C%20cream%20and%20coral%20tones%2C%20artful%20composition%2C%20high%20detail&width=800&height=500&seq=card-variety-01&orientation=landscape",
  },
  {
    id: "n03",
    cat: "热剧观察",
    title: "正在热播的都市群像剧迎来关键转折，多个副线走势成追剧焦点",
    summary: "剧情进入中后段，多条人物线开始收束。观众对角色成长线评价积极，也有网友提出不同看法，剧评区讨论氛围火热。",
    time: "2026.09.06 07:20",
    views: "52.3万",
    hot: true,
    img: "https://readdy.ai/api/search-image?query=drama%20city%20street%20scene%20at%20dusk%20with%20warm%20coral%20and%20amber%20color%20grade%2C%20editorial%20cinematic%20still%2C%20soft%20glow%2C%20cream%20backdrop%2C%20artful%20layered%20composition%2C%20high%20detail&width=800&height=500&seq=card-drama-01&orientation=landscape",
  },
  {
    id: "n04",
    cat: "新片快讯",
    title: "一部高概念悬疑新片放出先导预告，烧脑设定引发网友拆解",
    summary: "短短两分钟的预告被网友反复暂停分析，细节处埋下多重伏笔。导演团队此前作品口碑不俗，这次的新题材尝试备受期待。",
    time: "2026.09.05 23:10",
    views: "61.9万",
    hot: true,
    img: "https://readdy.ai/api/search-image?query=mystery%20film%20concept%20poster%20with%20geometric%20shadows%20and%20silhouette%2C%20warm%20amber%20and%20deep%20coral%20color%20grade%2C%20editorial%20cinematic%20style%2C%20soft%20dramatic%20light%2C%20cream%20backdrop%2C%20artful%20composition%2C%20high%20detail&width=800&height=500&seq=card-film-01&orientation=landscape",
  },
  {
    id: "n05",
    cat: "圈内动态",
    title: "多档综艺官宣常驻阵容调整，谁去谁留让粉丝团操碎了心",
    summary: "阵容变动消息一出，各家讨论区都热闹起来。有人期待新鲜搭配，也有人不舍老面孔，话题热度持续走高。",
    time: "2026.09.05 21:45",
    views: "33.8万",
    hot: false,
    img: "https://readdy.ai/api/search-image?query=television%20studio%20camera%20and%20cast%20chairs%20under%20warm%20stage%20lights%2C%20coral%20and%20amber%20color%20grade%2C%20editorial%20entertainment%20photography%2C%20soft%20cinematic%20glow%2C%20cream%20backdrop%2C%20artful%20composition%2C%20high%20detail&width=800&height=500&seq=card-studio-01&orientation=landscape",
  },
  {
    id: "n06",
    cat: "热梗速递",
    title: "来自新剧的对白梗正在刷屏，网友已经用它造句出了一百种玩法",
    summary: "一句高还原度的台词配上角色表情，在社交平台快速发酵。二创表情包层出不穷，成为最近两天最出圈的网络热梗。",
    time: "2026.09.05 20:30",
    views: "47.1万",
    hot: true,
    img: "https://readdy.ai/api/search-image?query=trending%20topic%20collage%20with%20speech%20bubbles%20and%20glowing%20text%20shapes%2C%20warm%20coral%20amber%20and%20cream%20palette%2C%20editorial%20digital%20art%2C%20soft%20lighting%2C%20playful%20composition%2C%20high%20detail&width=800&height=500&seq=card-meme-01&orientation=landscape",
  },
  {
    id: "n07",
    cat: "今日速报",
    title: "音乐平台新歌周榜出炉，多首影视OST闯入前排",
    summary: "榜单显示影视原声带占比明显提升，OST正在成为听众日常歌单的重要组成部分。哪首最耐听，网友们各有高见。",
    time: "2026.09.05 18:05",
    views: "29.6万",
    hot: false,
    img: "https://readdy.ai/api/search-image?query=music%20chart%20visual%20with%20vinyl%20records%20and%20audio%20waves%2C%20warm%20amber%20and%20coral%20color%20grade%2C%20editorial%20design%2C%20soft%20cinematic%20light%2C%20cream%20backdrop%2C%20artful%20composition%2C%20high%20detail&width=800&height=500&seq=card-music-01&orientation=landscape",
  },
  {
    id: "n08",
    cat: "热剧观察",
    title: "一部年代剧靠细节走红，服化道考究程度获观众点赞",
    summary: "从场景陈设到生活器物都下足功夫，观众直呼沉浸感拉满。制作团队的认真态度成为这部剧圈粉的重要原因。",
    time: "2026.09.05 16:50",
    views: "40.4万",
    hot: false,
    img: "https://readdy.ai/api/search-image?query=period%20drama%20set%20design%20with%20vintage%20furniture%20and%20warm%20incandescent%20lighting%2C%20amber%20and%20coral%20color%20grade%2C%20editorial%20cinematic%20photography%2C%20soft%20glow%2C%20cream%20backdrop%2C%20artful%20composition%2C%20high%20detail&width=800&height=500&seq=card-era-01&orientation=landscape",
  },
];

export const communityPosts = [
  { id: "c01", author: "凌晨三点半", tag: "追剧组", text: "这周更新的两集节奏太稳了，导演很会藏信息，结局绝对有反转，先立个flag。", likes: 2846, comments: 328 },
  { id: "c02", author: "今天也想早睡", tag: "吃瓜围观", text: "新综预告我反复看了五遍，嘉宾化学反应太妙了，希望正片别垮掉。", likes: 1932, comments: 217 },
  { id: "c03", author: "柚子茶不加糖", tag: "歌单分享", text: "把最近几部剧的OST打包循环了一天，质量是真的能打，求同好交流歌单。", likes: 1577, comments: 186 },
  { id: "c04", author: "一只爱看片的猫", tag: "影院线人", text: "周末冲了两部新片，一部爽片一部剧情片，都值回票价，等你们repo。", likes: 2210, comments: 264 },
];

export const faqs = [
  {
    q: "71吃瓜多久更新一次？",
    a: "我们保持高频更新，每日速报通常在当天早中晚三个时段集中推送，遇到突发热点会在第一时间跟进补发，确保你看到的都是最新动态。",
  },
  {
    q: "首页的速报和快报有什么区别？",
    a: "速报更偏当日要点汇总，适合快速了解发生了什么；快报则聚焦单条热点的跟进与背景梳理，方便追一个话题追到底。两者互为补充。",
  },
  {
    q: "网站里的内容可以转载或分享吗？",
    a: "欢迎把页面的链接分享给朋友一起讨论。若要转载站内整理的原创内容，建议注明来源，避免传播失实或遗漏关键信息。",
  },
  {
    q: "我发现了新热点，如何反馈给你们？",
    a: "你可以通过页面底部的联系方式给我们留言，把线索或链接发给我们，编辑团队核实后会尽快纳入跟进，也会感谢每一位提供线索的瓜友。",
  },
];

export const catBrowse = [
  {
    cat: "今日速报",
    icon: "ri-flashlight-line",
    lead: "当日要点一网打尽，速读发生了什么、谁在热议。",
    topics: ["档期调整", "定档官宣", "周榜出炉", "新片情报"],
    heat: "高",
  },
  {
    cat: "热剧观察",
    icon: "ri-film-line",
    lead: "热播剧逐集拆解，人物线、伏笔与口碑走势一起聊。",
    topics: ["都市群像", "年代细节", "OST 上头", "副线CP"],
    heat: "高",
  },
  {
    cat: "综艺现场",
    icon: "ri-mic-line",
    lead: "节目官宣、阵容变动与现场路透，第一时间送到眼前。",
    topics: ["野外冒险", "阵容官宣", "舞台竞演", "路透图"],
    heat: "中高",
  },
  {
    cat: "新片快讯",
    icon: "ri-movie-2-line",
    lead: "定档、预告与物料齐发，进影院前先来这里探路。",
    topics: ["暑期档", "先导预告", "高概念", "红毯造型"],
    heat: "中高",
  },
  {
    cat: "圈内动态",
    icon: "ri-building-2-line",
    lead: "影视综幕后动态与业界动向，看看圈里都在忙什么。",
    topics: ["栏目周年", "阵容调整", "业界动向", "幕后细节"],
    heat: "中",
  },
  {
    cat: "热梗速递",
    icon: "ri-emotion-happy-line",
    lead: "出圈台词、二创与表情包速递，跟上网络热梗不掉队。",
    topics: ["对白梗", "表情包", "二创疯传", "造句挑战"],
    heat: "高",
  },
];

export const stats = [
  { num: "6 大栏目", label: "速报·快报·热梗全覆盖" },
  { num: "15 分钟", label: "热榜自动刷新周期" },
  { num: "24 小时", label: "热点不缺席随时跟进" },
  { num: "1 处入口", label: "新瓜随手翻拿起接着看" },
];